import { render, staticRenderFns } from "./V2OrderSuccessModal.vue?vue&type=template&id=88adf272&scoped=true&"
import script from "./V2OrderSuccessModal.vue?vue&type=script&lang=js&"
export * from "./V2OrderSuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./V2OrderSuccessModal.vue?vue&type=style&index=0&id=88adf272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88adf272",
  null
  
)

export default component.exports